import React, { ReactNode } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import {
  CHECK_LIST_ROUTE_PATH,
  LOGIN_OTP_ROUTE_PATH,
  LOGIN_ROUTE_PATH,
  REGISTER_RESTAURANT_LOGO_ROUTE_PATH,
  REGISTER_RESTAURANT_ROUTE_PATH,
  REGISTER_ROUTE_PATH,
} from "./AppNavUrls.constant";
import Loading from "src/Shared/Components/Loading";
import { isAuthUser } from "src/Commons/Auth/Service/Auth.service";
import { lazyWithRetry } from "src/Shared/Utils/lazyWithRetry";

const Login = lazyWithRetry(() => import("src/Commons/Auth/Login"));
const OTP = lazyWithRetry(
  () => import("src/Commons/Auth/Login/Components/OTP"),
);
const Register = lazyWithRetry(() => import("src/Commons/Auth/Register"));

const RegisterRestaurant = lazyWithRetry(
  () => import("src/Commons/Auth/Register/Components/RegisterRestaurant"),
);

const LOGO = lazyWithRetry(
  () =>
    import(
      "src/Commons/Auth/Register/Components/RegisterRestaurant/RegisterLogoPage"
    ),
);

const AnonymousRoute: React.FC = () => {
  const { push } = useHistory();

  // const redirectToOderIfAuthenticated = () => {
  //   if (isAuthUser()) {
  //     push(CHECK_LIST_ROUTE_PATH);
  //   }
  //   return <></>;
  // };
  return (
    <React.Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path={LOGIN_ROUTE_PATH} component={Login} />
        <Route exact path={LOGIN_OTP_ROUTE_PATH} component={OTP} />
        <Route exact path={REGISTER_ROUTE_PATH} component={Register} />
        <Route
          exact
          path={REGISTER_RESTAURANT_ROUTE_PATH}
          component={RegisterRestaurant}
        />
        <Route
          exact
          path={REGISTER_RESTAURANT_LOGO_ROUTE_PATH}
          component={LOGO}
        />
      </Switch>
    </React.Suspense>
  );
};
export default AnonymousRoute;
